import { render, staticRenderFns } from "./UserAuthGroupsAdmin.vue?vue&type=template&id=6705cee2&scoped=true"
import script from "./UserAuthGroupsAdmin.vue?vue&type=script&lang=js"
export * from "./UserAuthGroupsAdmin.vue?vue&type=script&lang=js"
import style0 from "./UserAuthGroupsAdmin.vue?vue&type=style&index=0&id=6705cee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705cee2",
  null
  
)

export default component.exports